/*
    A service used to trigger Omniture events
*/
webClient.factory('omnitureService', ['$window',
    function ($window) {

        return {

            SEARCH_PAGE: "Recherche:Vol",
            FLIGHT_TUNNEL: "TUNNEL VOL",
            FLIGHT_CONFIRMATION: "CONF COMMANDE VOL-Voyage",

            PURCHASE_1_VOL: "PURCHASE 1 VOL",
            PURCHASE_2_VOL: "PURCHASE 2 VOL",
            PURCHASE_3_VOL: "PURCHASE 3 VOL",
            PURCHASE_4_VOL: "PURCHASE 4 VOL",
            CONFIRMATION: "CONFIRMATION COMMANDE",

            isActivated: function () {
                return (typeof s !== 'undefined' && s != null);
            },

            sendEvent: function (pageName, prop7, data) {

                if (typeof s !== 'undefined' && s != null) {

                    console.log("pageName: " + pageName);
                    console.log("prop7: " + prop7);

                    s.pageName = pageName;
                    s.prop7 = prop7;
                    s.prop2 = "Voyage";
                    if (pageName === 'HomeHotel') {
                        s.prop3 = "Hôtel";
                    }
                    else {
                        s.prop3 = "Vol";
                    }
                    s.prop24 = "1";

                    var cdiscountLoginGuid = $window.sessionStorage.getItem("cdiscountCustomerGuid");

                    //console.log("cdiscountLoginGuid: " + cdiscountLoginGuid);

                    if (isTablet) {
                        s.eVar93 = 'Tablet';
                    }
                    else if (isMobile) {
                        s.eVar93 = 'SMS';
                    }
                    else {
                        s.eVar93 = 'PC';
                    }

                    if (typeof cdiscountLoginGuid !== 'undefined' && cdiscountLoginGuid != null) {
                        s.eVar58 = cdiscountLoginGuid;
                    }

                    if (pageName == this.SEARCH_PAGE) {

                        var request = data;

                        s.eVar9 = this.getEvar9(prop7, request);
                        s.eVar105 = this.getEvar105(prop7, request);
                        s.eVar106 = this.getEvar106(prop7, request);

                        s.events = "event1";

                        //criteo
                        this.setViewSearch(request);
                        this.pushCriteo({ event: "viewList", item: ["cdvols"], ui_section: "vols" }, this.getViewSearch());

                    }
                    else if (pageName == this.PURCHASE_1_VOL) {

                        var request = data.request;
                        var price = data.totalAmount;

                        $window.sessionStorage.setItem('omnitureProductId', this.getProduct(prop7, request, price));
                        $window.sessionStorage.setItem('omnitureProductId', this.getProduct(prop7, request, price));

                        s.products = $window.sessionStorage.getItem('omnitureProductId');
                        s.events = "event248,scView";

                        //criteo
                        this.setViewBasket(request, price);
                        this.pushCriteo(this.getViewSearch(), this.getViewBasket());

                    }
                    else if (pageName == this.PURCHASE_2_VOL) {

                        s.products = $window.sessionStorage.getItem('omnitureProductId');
                        s.events = "event249";

                        //criteo
                        this.pushCriteo(this.getViewSearch(), this.getViewBasket());
                    }
                    else if (pageName == this.PURCHASE_3_VOL) {

                        s.products = $window.sessionStorage.getItem('omnitureProductId');
                        s.events = "event250";

                        //criteo
                        if ($window.$scope.bkgData.prixTotal) {
                            this.updateViewBasket($window.$scope.bkgData.prixTotal);
                        }
                        this.pushCriteo(this.getViewSearch(), this.getViewBasket());
                    }
                    else if (pageName == this.PURCHASE_4_VOL) {

                        s.products = $window.sessionStorage.getItem('omnitureProductId');
                        s.events = "event251";

                        //criteo
                        this.pushCriteo(this.getViewSearch(), this.getViewBasket());
                    }
                    else if (pageName == this.FLIGHT_CONFIRMATION) {

                        s.products = $window.sessionStorage.getItem('omnitureProductId');
                        s.events = "purchase";

                        //criteo
                        this.pushCriteo(this.getViewSearch(), this.getTrackTransaction($window.$scope.bkgData.bookingResponse.numbers[0].bookingNumber));

                        //GA
                        this.pushGA($window.$scope.bkgData.prixTotal.value, $window.$scope.bkgData.bookingResponse.numbers[0].bookingNumber);
                    }

                    var params = this.getUrlVars();

                    if (typeof params['event'] !== 'undefined' && params['event'] != null) {
                        s.events +=  ',' + params['event'];
                    }

                    s.t();  //fires tracking
                }

                //AWIN convertion traker
                if (pageName == this.FLIGHT_CONFIRMATION) {

                    var AWIN = {};
                    AWIN.Tracking = {};
                    AWIN.Tracking.Sale = {};

                    var voucher = '';

                    if ($window.$scope.bkgData.bookingRequest.discountCode) {
                        voucher = window.$scope.bkgData.bookingRequest.discountCode;
                    }

                    /*** Set your transaction parameters ***/
                    AWIN.Tracking.Sale.amount = $window.$scope.bkgData.prixTotal.value;//"totalAmount";
                    AWIN.Tracking.Sale.channel = "aw";
                    AWIN.Tracking.Sale.currency = "EUR";
                    
                    AWIN.Tracking.Sale.orderRef = $window.$scope.bkgData.bookingResponse.numbers[0].bookingNumber;//"orderReference";
                    AWIN.Tracking.Sale.parts = 'VOL:' + $window.$scope.bkgData.prixTotal.value;//"commissionGroup:totalAmount";
                    AWIN.Tracking.Sale.voucher = voucher;//"voucherCode";

                    $.getScript("https://www.dwin1.com/14021.js", function () { console.log('dwin script loaded') });

                    $('<img />', {
                        src: 'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=14021&amount=' + AWIN.Tracking.Sale.amount + '&ch=aw&cr=EUR&parts=' + AWIN.Tracking.Sale.parts + '&ref=' + AWIN.Tracking.Sale.orderRef + '&vc=' + AWIN.Tracking.Sale.voucher,
                        width: '0px',
                        height: '0px',
                        style: 'display: none;'
                    }).appendTo($('body'));
                }

                //KAYAK
                if (pageName == this.FLIGHT_CONFIRMATION) {

                    var KAYAK = {};
                    KAYAK.Tracking = {};
                    KAYAK.Tracking.Sale = {};
                    KAYAK.Tracking.Sale.amount = $window.$scope.bkgData.prixTotal.value;//"totalAmount";
                    KAYAK.Tracking.Sale.orderRef = $window.$scope.bkgData.bookingResponse.numbers[0].bookingNumber;//"orderReference";
                    KAYAK.Tracking.Sale.rand = Math.floor(Math.random() * Math.floor(10000));

                    $('<img />', {
                        src: 'https://www.kayak.com/s/kayakpixel/confirm/CDISCOUNT?kayakclickid={kayakclickid}&price=' + KAYAK.Tracking.Sale.amount + '&currency=EUR&confirmation=' + KAYAK.Tracking.Sale.orderRef + '&rand=' + KAYAK.Tracking.Sale.rand,
                        width: '0px',
                        height: '0px',
                        style: 'display: none;'
                    }).appendTo($('body'));
                }
            },

            getProduct: function (prop7, r, price) {

                if (prop7 == this.FLIGHT_TUNNEL) {
                    var lastIti = r.itineraries[r.itineraries.length - 1];
                    var o = r.origin;
                    var d = r.multiDestination ? lastIti.destination : r.destination;
                    var quantity = "1";

                    return ";" + o.cityName + "/" + d.cityName + "/;" + quantity + ";" + price.value;
                }

            },

            getEvar9: function (prop7, r) {

                if (prop7 == this.SEARCH_PAGE) {
                    var lastIti = r.itineraries[r.itineraries.length - 1];
                    var o = r.origin;
                    var d = r.multiDestination ? lastIti.destination : r.destination;

                    return o.cityName + " - " + d.cityName;
                }
                
            },

            getEvar105: function (prop7, r) {

                if (prop7 == this.SEARCH_PAGE) {

                    var isMulti = r.multiDestination;
                    var lastIti = r.itineraries[r.itineraries.length - 1];
                    var lastDate = isMulti ? lastIti.goDate : r.goDate2;
                    if (!r.oneWay) { // no return date in one way
                        return r.goDate.dateString + " - " + lastDate.dateString;
                    }
                    return r.goDate.dateString;
                }
            },

            setViewSearch: function (r) {

                    var prop = { event: 'viewSearch' };

                    var isMulti = r.multiDestination;
                    var lastIti = r.itineraries[r.itineraries.length - 1];
                    var lastDate = isMulti ? lastIti.goDate : r.goDate2;
                    if (!r.oneWay) { // no return date in one way
                        prop.checkout_date = this.formatDate(lastDate.dateString);
                    }
                    prop.checkin_date = this.formatDate(r.goDate.dateString);

                    $window.sessionStorage.setItem('criteoViewSearch', JSON.stringify(prop));
            },

            getViewSearch: function () {
                return JSON.parse($window.sessionStorage.getItem('criteoViewSearch'));
            },

            setViewBasket: function (r, price) {
                var prop = { event: "viewBasket", ui_section: "vols", item: [{id: "cdvols", price: price.value, quantity: r.totalPaxes }]};
                $window.sessionStorage.setItem('criteoViewBasket', JSON.stringify(prop));
            },

            updateViewBasket: function (price) {
                var prop = this.getViewBasket();
                prop.item[0].price = price.value;
                $window.sessionStorage.setItem('criteoViewBasket', JSON.stringify(prop));
            },

            getViewBasket: function () {
                return JSON.parse($window.sessionStorage.getItem('criteoViewBasket'));
            },

            getTrackTransaction: function (orderId) {
                var prop = JSON.parse($window.sessionStorage.getItem('criteoViewBasket'));

                return {
                    event: "trackTransaction", 
                    id: orderId, 
                    ui_section: "vols", 
                    item: prop.item
                };

            },

            getEvar106: function (prop7, r) {

                if (prop7 == this.SEARCH_PAGE) {
                    return r.adults + r.childs + r.infants;
                }
            },

            getCookie: function (name) {
                var value = "; " + document.cookie;
                var parts = value.split("; " + name + "=");
                if (parts.length == 2) return parts.pop().split(";").shift();
            },

            getUrlVars: function() {
                var vars = {};
                var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                    vars[key] = value;
                });
                return vars;
            },

            pushCriteo: function (arg1, arg2, arg3) {
                if (typeof window.criteo_q !== 'undefined' && window.criteo_q != null) {
                    window.criteo_q.push( { event: "setAccount", account: 52511 }, arg1, arg2, arg3);
                }
            },

            pushGA: function (price, orderId) {
                if (typeof gtag !== 'undefined' && gtag != null) {
                    gtag('event', 'conversion', {
                      'send_to': 'AW-938777661/QbG8CIOe4Y8BEL240r8D',
                      'value': price,
                      'currency': 'EUR',
                      'transaction_id': orderId
                  });
                }
            },

            //format a date from dd/MM/yyyy to yyyy-MM-dd
            formatDate: function (value) {
                return value.substring(6, 10) + '-' +  value.substring(3, 5) + '-' + value.substring(0, 2);
            }
        };
    }]);

